import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IWhistleBlowListItem, WhistleBlowListItem } from "./whistleBlowListItem";

export interface IWhistleBlowListItems extends ListItems<IWhistleBlowListItem> {
}

export class WhistleBlowListItems extends ListItems<WhistleBlowListItem> implements IWhistleBlowListItems {
    constructor();
    constructor(obj: IWhistleBlowListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, WhistleBlowListItem);
    }
}